// import Swiper from 'swiper';
// import { Autoplay, EffectFade } from 'swiper/modules';

const setHeaderHeight = () => {
  const header = document.querySelector('.header');
  if (header) {
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }
};

const sliderHero = () => {
  const sliders = document.querySelectorAll('.slider-hero');
  if (!sliders.length) return;

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  const restartZoom = (swiper) => {
    swiper.slides.forEach(slide => slide.classList.remove('is-animating'));
    const active = swiper.slides[swiper.activeIndex];
    if (!active) return;
    void active.offsetWidth; // force reflow per riavviare il keyframe
    active.classList.add('is-animating');
  };

  sliders.forEach(slider => {
    new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      on: {
        afterInit: restartZoom,
        slideChangeTransitionStart: restartZoom,
      },
    });
  });
};

export default sliderHero;
